
export class NotificationAlert {
   constructor(
     public  Id:string,
     public  Alert: string,
     public AlertMessage: string,
     public AlertIcon: string,
     public AlertClass: string,
     public TextColor: string
   ) {
     this.Id= (Math.random() * 100000).toFixed(0);
   }
}






